import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  query($order: [UsersFindOrder!],$where: UsersFindFilter) {\n    exportManagersList(\n      order: $order,\n      where: $where\n    ) {\n      fileName\n      contentB64\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  query($where: UsersFindFilter, $order: [UsersFindOrder!], $paging: PagingQuery) {\n    findManagers(\n      where: $where,\n      order: $order,\n      paging: $paging\n    ) {\n      users {\n        id\n        username\n        phone\n        role\n      }\n      paging {\n        totalCount\n        take\n        currentOffset\n      }\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  mutation($userId: Int!) {\n    deleteUser(userId: $userId)\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation($input: EditUserInput!, $userId: Int!) {\n    updateUser(input: $input, userId: $userId) {\n      id\n      username\n      phone\n      role\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation($input: NewUserInput!) {\n    createUser(input: $input) {\n      id\n      username\n      phone\n      role\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var createUser = gql(_templateObject());
export var updateUser = gql(_templateObject2());
export var deleteUser = gql(_templateObject3());
export var findManagers = gql(_templateObject4());
export var exportManagersList = gql(_templateObject5());